import { takeLatest } from 'redux-saga/effects';
import {
  getFarmListSuccess, getFarmListFail,
  getFarmDetailsSuccess, getFarmDetailsFail
} from './farmState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/admin/accounts');
const redirectData = {route:'/console/accounts', mode: 'list', recordId:0 };
const modelName = 'Farms';
const modelId = 'id';

function* getFarmList(data) {
	const { accountId, ...params } = data.payload;
	const childEndpoint = `${accountId}/farms`;
	yield doCrudCall(
		() => crudService.getList(params, childEndpoint), 
		getFarmListSuccess, 
		getFarmListFail);
}

function* getFarmDetails(data) {
	const { accountId, recordId } = data.payload;
	const childEndpoint = `${accountId}/farms`;
	yield doCrudCall(
		() => crudService.getDetails(recordId, childEndpoint), 
		getFarmDetailsSuccess, 
		getFarmDetailsFail);		
}

function* doFarmCreate(data){
	const childEndpoint = `${data.payload.account_id}/farms`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint), 
		getFarmDetailsSuccess, 
		getFarmDetailsFail,
		`${modelName} record has been created.`,
		{...redirectData, route:`/console/accounts/${data.payload.account_id}/view`});
}

function* doFarmUpdate(data){
	const childEndpoint = `${data.payload.account_id}/farms`;
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload, childEndpoint), 
		getFarmDetailsSuccess, 
		getFarmDetailsFail,
		`${modelName} record has been updated.`,
		{...redirectData, route:`/console/accounts/${data.payload.account_id}/farms/${data.payload[modelId]}/view`});	
}

function* doFarmDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getFarmDetailsSuccess, 
		getFarmDetailsFail,
		`${modelName} record has been deleted.`,
		{...redirectData, route:`/console/accounts/${data.payload.account_id}/view`});	
}

function* farmSaga() {
  yield takeLatest('farm/getFarmList', getFarmList);
  yield takeLatest('farm/getFarmDetails', getFarmDetails);
  yield takeLatest('farm/doFarmCreate', doFarmCreate);
  yield takeLatest('farm/doFarmUpdate', doFarmUpdate);
  yield takeLatest('farm/doFarmDelete', doFarmDelete);  
}

export default farmSaga;
